"use strict";
// Copyright (c) 2025 The Bitcoin developers
// Distributed under the MIT software license, see the accompanying
// file COPYING or http://www.opensource.org/licenses/mit-license.php.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENESIS_TOKEN_ID_PLACEHOLDER = void 0;
/**
 * We do not yet know the tokenId of a token involved in a GenesisAction
 * We use a placeholder token to distinguish GENESIS PaymentTokenOutput[] from MINT
 * PaymentTokenOutput[]; see payment/output.ts
 */
exports.GENESIS_TOKEN_ID_PLACEHOLDER = 'GENESIS_TOKEN_ID_PLACEHOLDER';
//# sourceMappingURL=action.js.map